<template>
  <div class="ux-spinner" :class="{ large: large }">
    <!-- <svg width="100" height="100" viewBox="0 0 50 50">
    <circle cx="25" cy="25" r="20" fill="none" stroke="#0d6efd" stroke-width="5" stroke-linecap="round">
        <animate attributeName="stroke-dasharray" from="1,200" to="100,200" begin="0s" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="stroke-dashoffset" from="0" to="-300" begin="0s" dur="2s" repeatCount="indefinite"/>
        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" begin="0s" dur="2s" repeatCount="indefinite"/>
    </circle>

</svg> -->
    <!-- <svg width="1em" height="1em" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="20" fill="none" stroke-width="0" stroke-linecap="round">
        <animate attributeName="stroke-dasharray" from="1,200" to="100,200" begin="0s" dur="2s" repeatCount="indefinite"/>
        <animate attributeName="stroke-dashoffset" from="0" to="-300" begin="0s" dur="2s" repeatCount="indefinite"/>
        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" begin="0s" dur="2s" repeatCount="indefinite"/>
    </circle>
</svg> -->
    <svg
      width="24"
      height="24"
      stroke="#000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="spinner_V8m1">
        <circle cx="12" cy="12" r="9.5" fill="none" stroke-width="2"></circle>
      </g>
    </svg>
  </div>
  <!-- <div class="ux-spinner" :class="{large:large}"><i class="fa fa-spin fa-spinner"/></div> -->
</template>
<script>
export default {
  props: {
    large: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-spinner {
  pointer-events: none;
  &.large {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    font-size: clamp(50px, 10vw, 500px);
    // opacity: 0.5;;
  }

  // svg circle {
  //     stroke: currentColor;
  //     stroke-width: 5;
  //     // #0d6efd"
  // }
  //
  svg {
    width: 1em !important;
    height: 1em !important;
    stroke: currentColor;
  }

  .spinner_V8m1 {
    transform-origin: center;
    animation: spinner_zKoa 1s linear infinite;
  }

  .spinner_V8m1 circle {
    stroke-linecap: round;
    animation: spinner_YpZS 0.8s ease-in-out infinite;
  }

  @keyframes spinner_zKoa {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spinner_YpZS {
    0% {
      stroke-dasharray: 0 150;
      stroke-dashoffset: 0;
    }

    47.5% {
      stroke-dasharray: 42 150;
      stroke-dashoffset: -16;
    }

    95%,
    100% {
      stroke-dasharray: 42 150;
      stroke-dashoffset: -59;
    }
  }

  &[lg] {
    font-size: 2em;
  }

  &[xl] {
    font-size: 4em;
  }

  &[xxl] {
    font-size: 6em;
  }
}
</style>
